import * as t from 'io-ts'

/**
 * CantonId is a newtype around 'string'. We check whether this string is
 * part of the allowed cantons at runtime and warn for unknown cantons.
 */
export interface CantonIdBrand {
  readonly CantonId: unique symbol
}

export const isCantonId = (_x: string): _x is t.Branded<string, CantonIdBrand> => true /* TODO */

export const CantonId = t.brand(t.string, isCantonId, 'CantonId')

export type CantonId = t.TypeOf<typeof CantonId>

/**
 * Return the CantonId value as a string
 */
export const unCantonId = (x: CantonId): string => x

/**
 * Create a new CantonId from a string in range [0..1]. If the input
 * is outside of that range, a warning is printed to the console.
 */
export const mkCantonId = (x: string): CantonId => {
  /*
  if (!allCantonIds.has(x as CantonId)) {
    console.warn(`mkCantonId: unknown CantonId "${x}"`)
  }
  */

  return x as CantonId
}
